"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExclusionReason = exports.Form1099Status = exports.Form1099DeliveryMethod = exports.Form1099DisputeStatus = exports.Form1099Type = exports.MemberTaxDocumentSharePermission = exports.MemberVerificationStrategy = exports.MemberClientTaxStatus = exports.MemberClientStatus = void 0;
var MemberClientStatus;
(function (MemberClientStatus) {
    MemberClientStatus["Active"] = "Active";
    MemberClientStatus["Inactive"] = "Inactive";
    MemberClientStatus["Pending"] = "Pending";
})(MemberClientStatus = exports.MemberClientStatus || (exports.MemberClientStatus = {}));
var MemberClientTaxStatus;
(function (MemberClientTaxStatus) {
    MemberClientTaxStatus["Complete"] = "Complete";
    MemberClientTaxStatus["Failed"] = "Failed";
    MemberClientTaxStatus["Pending"] = "Pending";
    MemberClientTaxStatus["Incomplete"] = "Incomplete";
})(MemberClientTaxStatus = exports.MemberClientTaxStatus || (exports.MemberClientTaxStatus = {}));
var MemberVerificationStrategy;
(function (MemberVerificationStrategy) {
    MemberVerificationStrategy["None"] = "None";
    MemberVerificationStrategy["All"] = "All";
})(MemberVerificationStrategy = exports.MemberVerificationStrategy || (exports.MemberVerificationStrategy = {}));
var MemberTaxDocumentSharePermission;
(function (MemberTaxDocumentSharePermission) {
    MemberTaxDocumentSharePermission["Allow"] = "Allow";
    MemberTaxDocumentSharePermission["Decline"] = "Decline";
})(MemberTaxDocumentSharePermission = exports.MemberTaxDocumentSharePermission || (exports.MemberTaxDocumentSharePermission = {}));
var Form1099Type;
(function (Form1099Type) {
    Form1099Type["NEC"] = "NEC";
})(Form1099Type = exports.Form1099Type || (exports.Form1099Type = {}));
var Form1099DisputeStatus;
(function (Form1099DisputeStatus) {
    Form1099DisputeStatus["Open"] = "Open";
    Form1099DisputeStatus["Closed"] = "Closed";
})(Form1099DisputeStatus = exports.Form1099DisputeStatus || (exports.Form1099DisputeStatus = {}));
var Form1099DeliveryMethod;
(function (Form1099DeliveryMethod) {
    Form1099DeliveryMethod["Electronic"] = "Electronic";
    Form1099DeliveryMethod["Mail"] = "Mail";
    Form1099DeliveryMethod["Both"] = "Both";
})(Form1099DeliveryMethod = exports.Form1099DeliveryMethod || (exports.Form1099DeliveryMethod = {}));
var Form1099Status;
(function (Form1099Status) {
    Form1099Status["Ready"] = "Ready";
    Form1099Status["NeedsActionInfo"] = "NeedsActionInfo";
    Form1099Status["NeedsActionDispute"] = "NeedsActionDispute";
    Form1099Status["Submitted"] = "Submitted";
    Form1099Status["Rejected"] = "Rejected";
    Form1099Status["Accepted"] = "Accepted";
    Form1099Status["Excluded"] = "Excluded";
})(Form1099Status = exports.Form1099Status || (exports.Form1099Status = {}));
var ExclusionReason;
(function (ExclusionReason) {
    ExclusionReason["BelowThreshold"] = "BelowThreshold";
    ExclusionReason["CompanyStructure"] = "CompanyStructure";
    ExclusionReason["NonUsEntity"] = "NonUsEntity";
})(ExclusionReason = exports.ExclusionReason || (exports.ExclusionReason = {}));
;
//# sourceMappingURL=memberClient.js.map